export default __webpack_public_path__ + "static/media/brake-per-100.847d4191.svg";